
import React from "react";
import { Route, Routes } from "react-router-dom";
import CertificateTypeDetail from "../../component/Certificate/CertificateTypeDetail";
import CertificateTypeForm from "../../component/Certificate/CertificateTypeForm";
import BasicTypePageTest from "../../component/Certificate/BasicTypePageTest";

function CertificatePage() {
  return (
    <Routes>
      <Route path="/*" element={<BasicTypePageTest />} />
       <Route path="/:id" element={<CertificateTypeDetail isEdit={true} />} />
      <Route path="/new" element={<CertificateTypeDetail isEdit={false} />} />
      
    </Routes>
  );
}

export default CertificatePage;
